require("!!C:\\Users\\nagender.chauhan\\Desktop\\panasonic\\dse_web_app\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\nagender.chauhan\\Desktop\\panasonic\\dse_web_app\\node_modules\\raw-loader\\index.js!C:\\Users\\nagender.chauhan\\Desktop\\panasonic\\dse_web_app\\node_modules\\jquery-slimscroll\\jquery.slimscroll.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery-slimscroll/jquery.slimscroll.js
// module id = 1064
// module chunks = 20